import React from 'react';
import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';

function TermsConditions() {
  return (
    <>
      <TopStrip />
      <Navbar />

      <section id="main" className="container" style={{ margin:'5rem auto' }} data-aos="fade-out">
        
        {/* ASSUMPTIONS & UPTIME */}
        <section className="py-5" id="assumptions-uptime">
          <div className="container">
            <h2 className="mb-4">Assumptions</h2>
            <ul className="list-group list-group-flush mb-5">
              <li className="list-group-item">DDevOps will provide ongoing operational support maintenance as described in Service Level Agreement.</li>
              <li className="list-group-item">DDevOps will not be responsible for any hardware failure and application bug, any problem related to infrastructure providers or any development issues with application.</li>
              <li className="list-group-item">All Subscription available on monthly, quarterly, biannually or yearly basis.</li>
              <li className="list-group-item">Services provided outside of scope of agreement are subject to an additional cost.</li>
              <li className="list-group-item">Major upgrades outside of the scope of agreement are treated as Hourly projects.</li>
              <li className="list-group-item">Changes to services will be communicated and documented in Service Charter Contract.</li>
              <li className="list-group-item">Service will be provided adherence to related policies, processes and procedures.</li>
              <li className="list-group-item">Scheduling requests will be conducted in accordance with service descriptions.</li>
              <li className="list-group-item">Support for non-subscribed servers and services are not included.</li>
              <li className="list-group-item">Backup and security settings are not a 100% guarantee against hardware loss or data corruption, and/or from the compromise application.</li>
              <li className="list-group-item">DDevOps is not responsible for loss and/or corrupted data that may occur when servicing client infrastructure.</li>
              <li className="list-group-item">Technical assistance and best effort is limited to couple of hours of troubleshooting assistance per incident.</li>
              <li className="list-group-item">Any assistance exceeding from 2 hours (per incident) will be notified and billed at hourly rate.</li>
            </ul>

            <h2 className="mb-4">Uptime</h2>
            <p>DDevOps provide 99.9% guaranteed uptime, in case we are unable to deliver guaranteed availability, lost time will be refunded back to your account.</p>
            <p>The guaranteed uptime is limited to the server availability from infrastructure provider. Any planned/unplanned maintenance from either side will be separated from it.</p>
            <div className="table-responsive">
              <table className="table table-bordered w-50">
                <thead className="table-light">
                  <tr><th>Period</th><th>Downtime</th></tr>
                </thead>
                <tbody>
                  <tr><td>Daily</td><td>1m 26.4s</td></tr>
                  <tr><td>Weekly</td><td>10m 4.8s</td></tr>
                  <tr><td>Monthly</td><td>43m 49.7s</td></tr>
                  <tr><td>Yearly</td><td>8h 45m 57.0s</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* SECURITY PRACTICES */}
        <section className="my-5">
          <div className="container">
            <h2 className="mb-4">Security Practices</h2>
            <p>DDevOps will configure server to comply with the system Security Standards and best practices. While these practices aim to reduce the likelihood of hacking and other compromises, DDevOps cannot guarantee against data loss due to issues in the application or outdated/vulnerable software.</p>
            <ul>
              <li>DDevOps will not support servers that do not comply with known standards and policies. Non-compliant servers will be unsubscribed until standards are restored.</li>
              <li>Servers handling Restricted Data will only be supported if hosted in a secure Data Center environment.</li>
              <li>Clients with administrative rights must follow security best practices. If any compromise is detected, rights may be revoked or limited.</li>
              <li>Clients are responsible for managing user access and notifying DDevOps about changes.</li>
              <li>DDevOps does not store user passwords and will never ask for them. Passwords are the user's responsibility.</li>
              <li>Any compromised server or application will be taken offline until minimum security standards are met.</li>
            </ul>
            <hr className="my-4" />
            <h4 className="mb-3">Backups</h4>
            <p><strong>Backup Retention Policy (Onsite/Offsite):</strong></p>
            <div className="table-responsive">
              <table className="table table-bordered text-center">
                <thead className="table-light">
                  <tr><th>Backup Type</th><th>Retention</th></tr>
                </thead>
                <tbody>
                  <tr><td>Daily</td><td>7</td></tr>
                  <tr><td>Weekly</td><td>2</td></tr>
                  <tr><td>Monthly</td><td>1</td></tr>
                  <tr><td>Database</td><td>15 Days</td></tr>
                </tbody>
              </table>
            </div>
            <p>Backup frequency can be increased according to the needs, there will be additional charges for offsite storage and configuration charges for additional backups.</p>
          </div>
        </section>

        {/* SLA */}
        <section className="my-5">
          <div className="container">
            <h2 className="mb-4">Service Level Agreement (SLA)</h2>
            <p>DDevOps provides quality services to their clients with maximum productivity, backed by this Service Level Agreement. This SLA is an integral part of the agreement and can be reviewed, revised, and supported by additional clauses as outlined in the contract.</p>
            <p className="mt-4"><strong>This SLA addresses:</strong></p>
            <ul>
              <li>The services DDevOps provides to the customer.</li>
              <li>Response times, availability, and maintenance associated with these services.</li>
              <li>Responsibilities of DDevOps as a Managed Service Provider for subscription-based services.</li>
              <li>Definition of scope of services &amp; responsibilities of clients receiving subscription-based services.</li>
              <li>Processes for requesting services, including technical assistance and expected response time.</li>
              <li>Review, reporting, and other operational processes.</li>
            </ul>
          </div>
        </section>

        {/* SCOPE OF SERVICE */}
        <section className="my-5">
          <div className="container">
            <h2 className="mb-4">Scope Of Service</h2>
            <p>DDevOps team of server administrators provides professional management of different servers, including in-house infrastructure, dedicated, virtual &amp; cloud environments, supported versions of server software for Linux and Microsoft.</p>
            <p className="mt-3 fw-bold">Server support subscription includes the following:</p>
            <ul>
              <li>Provision of server (OS &amp; other software requirements).</li>
              <li>Deployment and configuration of firewall.</li>
              <li>Initial setup and configuration of server.</li>
              <li>Installation and configuration of application along with required packages on server.</li>
              <li>Monitoring of production applications, running services and server resources.</li>
              <li>Documentation, configuration, and change log.</li>
              <li>Maintenance and security update management.</li>
              <li>Hardware upgrades and scaling supported by the infrastructure provider.</li>
              <li>Configuration &amp; maintenance of onsite/offsite backups.</li>
              <li>Troubleshooting ongoing issues and providing solutions.</li>
            </ul>

            <div className="row mt-5">
              <div className="col-md-6">
                <h5 className="fw-bold">Managed Services</h5>
                <ul className="list-group list-group-flush">
                  {['Web Server Management','Database Server Management','Mail Server and Email Management','DNS Server and DNS Management','Backup Server Management','Control Panel Management','Infrastructure Support','Proactive Monitoring','Support for Linux and Windows Platforms','OS Upgrade and Patches','Server Security and Firewall Configuration','Data Migration','Application Migration','Security Patches and Server Packages'].map((item,i) => (
                    <li className="list-group-item" key={i}>{item} <strong className="text-success float-end">X</strong></li>
                  ))}
                </ul>
              </div>
              <div className="col-md-6">
                <h5 className="fw-bold">Data Protection (Backup Policy)</h5>
                <ul className="list-group list-group-flush">
                  {['Backup Configuration','Users & Permissions','Ports & Protocols','Application(s) Data','Configuration Data','Databases','DR Assistance'].map((item,i) => (
                    <li className="list-group-item" key={i}>{item} <strong className="text-success float-end">X</strong></li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-5">
              <h5 className="fw-bold">Other Services</h5>
              <ul className="list-group list-group-flush">
                {['SSL (HTTPS) Support','Technical Support','Security Assistance','Technology Consultation','Infrastructure Support','Technical Correspondence with other providers'].map((item,i) => (
                  <li className="list-group-item" key={i}>{item} <strong className="text-success float-end">X</strong></li>
                ))}
              </ul>
            </div>

            <div className="mt-5">
              <h5 className="fw-bold">Ecommerce Operations and DDevOps Services</h5>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr><th>Service</th><th>Billing Type</th><th>Terms</th></tr>
                  </thead>
                  <tbody>
                    {['Proxy Servers and Load Balancer','Advanced Web Support','Third Party Software Installation','Multi-tier Setup and Support','Multi-Environment/Location Setup','Software Support','Custom Server Setup','Application/Software Upgrade','Security Assistance & Data Encryption','Credential Protection','Deployment/Migration Assistance','Disaster Recovery & DR Drill','Continuous Integration & Delivery','Custom/Dedicated Solution','Security and System Audits','High Availability/Clustering','Testing & Training'].map((svc,i) => (
                      <tr key={i}><td>{svc}</td><td>Hourly</td><td>According to Contract</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-3"><strong>Note:</strong> <em>X indicates the service is included in the base managed services package.</em></p>
              <p>There will be 2 hours daily for DDevOps Services for high-level tasks. Any additional hours will be billed accordingly. Please refer to your contract for subscribed features &amp; hourly rates.</p>
            </div>
          </div>
        </section>

        {/* SERVICES OUTSIDE SCOPE */}
        <section className="my-5">
          <div className="container">
            <h2 className="mb-4">Services Outside of the Scope</h2>
            <p>Services outside of the scope of this Service Level Agreement are considered optional and will be billed at DDevOps Hourly rate.</p>
            <p>These services may include, but are not limited to:</p>
            <ul>
              <li>Any technical troubleshooting on Server handled by Technical Team.</li>
              <li>Setup &amp; Configuration of any unsupported services.</li>
              <li>Installation, configuration and/or troubleshooting of any unsupported software &amp; applications.</li>
              <li>Vendor assistance for third party tools.</li>
              <li>Services can be designed to meet specific business requirements in DDevOps Services. For more information, please contact <a href="mailto:Support@DDevOps.com">Support@DDevOps.com</a>.</li>
              <li>DDevOps can provide Technology Consultation to assist in planning infrastructure, software, hardware, and security needs.</li>
            </ul>
          </div>
        </section>

        {/* BACKUP LIABILITY */}
        <section className="my-5 bg-light p-4 rounded">
          <div className="container">
            <h2 className="mb-4">Backup Liability</h2>
            <p>DDevOps provides automatic scheduled backups, but these do not replace the need for offsite backups for disaster recovery.</p>
            <ul>
              <li>Recommended to back up offsite at regular intervals for best recovery.</li>
              <li>Automatic scheduled backups include Configuration, Web files &amp; folders, and databases.</li>
              <li>Local-only backups are not considered adequate for disaster recovery.</li>
              <li>Backup does not guarantee full recovery to last known state (depends on policy).</li>
              <li>DDevOps commits to protecting supported servers from deliberate damage.</li>
              <li>DDevOps is not liable for hardware/data loss caused by accidental actions on either side.</li>
              <li>Recovery support will be provided if backups are present but complete restoration is not guaranteed.</li>
              <li>Each DDevOps member is responsible for protecting client's information, resources, and assets.</li>
              <li>Risk evaluation for each server will be done quarterly or on client request.</li>
              <li>Security risks found will be reported and mitigation will be scheduled with client.</li>
            </ul>
          </div>
        </section>

        {/* ROLES & CONTACT */}
        <section className="my-5">
          <div className="container">
            <h2 className="mb-4">Roles and Responsibilities</h2>
            <div className="row">
              <div className="col-md-6">
                <h5 className="fw-bold">DDevOps Responsibilities:</h5>
                <ul>
                  <li>Meeting response times for service-related incidents or requests.</li>
                  <li>Notifying customers of maintenance, outages, or changes.</li>
                  <li>Implementing effective support processes.</li>
                  <li>Providing professional staff and secure communication.</li>
                  <li>Ensuring secure system configurations and compliance.</li>
                </ul>
              </div>
              <div className="col-md-6">
                <h5 className="fw-bold">Customer Responsibilities:</h5>
                <ul>
                  <li>Being available during service incidents to assist resolution.</li>
                  <li>Submitting service requests through proper channels.</li>
                  <li>Making timely payments for licenses and services.</li>
                  <li>Ensuring data is backed up and notifying changes in user access.</li>
                  <li>Allowing remote tools for support when needed.</li>
                </ul>
              </div>
            </div>

            <hr className="my-5" />

            <h2 className="mb-4">Contact Information</h2>
            <ul>
              <li><strong>Support Email &amp; Ticketing:</strong> <a href="mailto:Support@DDevOps.com">Support@DDevOps.com</a></li>
              <li><strong>Helpdesk:</strong> <a href="http://Support.DDevOps.com/">http://Support.DDevOps.com/</a></li>
              <li><strong>Chat:</strong> Available during normal business hours</li>
              <li><strong>Account Owner:</strong> Provided via Ecommerce Operation or DDevOps Services</li>
              <li><strong>DDevOps Management:</strong> <a href="mailto:teamlead@ddevops.com">teamlead@ddevops.com</a></li>
              <li><strong>Emergency Contact:</strong> Phone number for urgent issues</li>
              <li><strong>Non-Subscribers:</strong> Contact via website or <a href="mailto:Info@DDevOps.com">Info@DDevOps.com</a></li>
            </ul>

            <hr className="my-5" />

            <h2 className="mb-4">Operations Hours &amp; Escalation</h2>
            <p><strong>Operation Hours:</strong> 7 a.m. – 7 p.m. GMT, Monday to Friday (excluding Federal holidays)</p>
            <p><strong>Urgent Technical Support:</strong> Available outside regular hours for critical issues.</p>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr><th>Priority</th><th>Initial Response Time</th><th>Support Initiation</th></tr>
                </thead>
                <tbody>
                  <tr><td><strong>Urgent</strong></td><td>0–30 minutes</td><td>0–1 hour</td></tr>
                  <tr><td><strong>High</strong></td><td>1 hour</td><td>1–2 hours</td></tr>
                  <tr><td><strong>Normal</strong></td><td>3 hours</td><td>3–6 hours or as scheduled</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default TermsConditions;
